import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonAPIService } from './common.service';
import * as CryptoJS from 'crypto-js';
import { UtilService } from './util.service';
import { Constant } from './data';


@Injectable({
  providedIn: 'root'
})
export class AuthentictionService implements OnInit {
  // url: any = environment.apiUrl;
  url: any;
  //codeUrl: any = 'https://panel.purpletv.app/api';
  // codeUrl: any = environment.cdnurl + 'https://panel.purpletv.app/api';
  keys:any = environment.p_keys;
  // codeUrl: any =  'https://cors.b-cdn.net/https://panel.purpletv.app/api';
  // codeUrl :any = 'https://cors.b-cdn.net/https://purpletvapi.b-cdn.net/appdetail?version=v2&app_type=Android&code=';
  // codeUrl:any='https://dev.login.purpletv.app/api/appdetail?code=';
  codeUrl:any=environment.codeUrl;
  // 'https://cors.guidemefast.com
  // xstreamUrl:any
  loginDetails:any=[];
  urlList:any;
  reg:any;
  list_m3u_update:any;
  list_xstream_update:any;
  delete_url:any;
  Ourl:any;
  OToken:any;
  domain: any = '';
  username: any = '';
  password: any = '';
  postUrl:any='';
  Xurl: any;
  headers:any;
  token:any;

  constructor( public http: HttpClient,private utilService:UtilService) {

    this.newPlayList()
    this.Ourl = this.utilService.getOneStreamUrl();
    this.OToken = this.utilService.getOneStreamToken();
    this.token = this.utilService.getValueCookie(Constant.USERTOKEN) || '';
        this.headers = new HttpHeaders({
          'Authorization': `Bearer ${this.token}`
        });
   }

  ngOnInit(): void {
    
  }

   isLogin(): boolean {
    const token = this.utilService.getValueCookie(Constant.USERTOKEN);
    return !!token; // true if token exists and is not empty
  }

 isPlayList(): boolean {
  const purple = JSON.parse(this.utilService.getValueStorage('purple_playlist') || '[]');
  const xstream = JSON.parse(this.utilService.getValueStorage('xstream_playlists') || '[]');
  const isCode = localStorage.getItem('iscode');
  const hasPurple = Array.isArray(purple) && purple.length > 0;
  const hasXstream = Array.isArray(xstream) && xstream.length > 0;

  return hasPurple || hasXstream || isCode == 'true';
}


  postDataUrl() {
    this.Xurl = this.utilService.getXstreamUrl();
    if (this.Xurl) {
      this.domain = this.utilService.getXstreamUrl();
      this.username = this.utilService.getXstreamUsername();
      this.password = this.utilService.getXstreamPassword();
    }else if (this.OToken){
      this.domain = this.utilService.getOneStreamUrl();
    } else {
      this.domain = this.utilService.getFullUrl();
      this.username = this.utilService.getFullUsername();
      this.password = this.utilService.getFullPassword();
    }
    const url = this.domain + '/player_api.php';
    return {
      url,
      username: this.username,
      password: this.password
    };
  }

  // validateXsream(){

  //   return this.http.get()
  // }
  validateXstreamGET(url: string, username: string, password: string) {
    return this.http.get(`${url}/player_api.php?username=${username}&password=${password}`);
  }
  
  validateXstreamPOST(url: string, username: string, password: string) {
    const body = new HttpParams()
      .set('username', username)
      .set('password', password);
    return this.http.post(`${url}/player_api.php`, body);
  }

  activateCodeLogin(params:any){
    const body = new HttpParams()
    .set('device_code',params.device_code)
    .set('mac_type',params.mac_type)
    .set('mac_address',params.mac_address)
    .set('ip_address',params.ip_address)
    .set('device_type',params.device_type)
    .set('platform',params.platform)
    .set('app_name',params.app_name)

    return this.http.post(`${environment.baseUrl}/verifyDeviceCode`,body)
  }

  playlistBydeviceId(param:any){
    const body = new HttpParams()
    .set('device_code',param)
    return this.http.post(`${environment.baseUrl}/playlistByDevice`,body)
  }
  

  newPlayList() {
  const headers = new HttpHeaders({
    'X-Requested-With': 'XMLHttpRequest'
  });

  this.http.get('https://cors.b-cdn.net/https://endpoint.purpletv.app/purpleweb/v2.json', { headers }).subscribe(res => {
    this.loginDetails = res;
    this.url = this.loginDetails.login;
    console.log("url", this.url);

    this.list_m3u_update = this.loginDetails.list_m3u_update;
    this.list_xstream_update = this.loginDetails.list_xstream_update;
    this.urlList = this.loginDetails.list_get;
    this.reg = this.loginDetails.register;
    this.delete_url = this.loginDetails.deleteurl;

    const agreement = this.loginDetails.agreement.privacy_policy;
    const termscondition = this.loginDetails.agreement.terms_condtion;

    localStorage.setItem('privacy', agreement);
    localStorage.setItem('terms', termscondition);
  });
}



  login(params: any) {
    console.log(params);

    const body = new HttpParams()
      .set(`email`, params.userid || params.email)
      .set(`password`, params.pwd || params.password)
    // return this.callURLEncodedApi(this.url + '/login.php', body);
    return this.callURLEncodedApi(`${environment.baseUrl}/login`, body);
  }

  loginMedia(data:any){
    const mediabody ={
      username:data.user_id,
      password:data.password
    }
    console.log(mediabody,'body');
    
    return this.http.post(`${environment.mediaBaseUrl}/login`,mediabody);
  }   
  registerMedia(data:any){
    const mediabody ={
      username:data.user_id,
      password:data.password
    }
    console.log(mediabody,'body');
    
    return this.http.post(`${environment.mediaBaseUrl}/register`,mediabody);
  }

  register(params: any) {
    const body = new HttpParams()
      .set(`first_name`, params.firstname)
      .set(`last_name`, params.lastname)
      .set(`email`,params.email)
      .set('password',params.password)
      
    return this.callURLEncodedApi(`${environment.baseUrl}/register`, body);
  }
  forgotPassword(param:any){
    const body = new HttpParams()
    .set(`email`,param.email)
    return this.callURLEncodedApi(`${environment.baseUrl}/forgot-password`,body);
  }

  loginWithCode(code) {
    return this.http.get(this.codeUrl  + code, { responseType: 'text' })
  }
  
  serverDnsLogin(dnsUrl,playlist, username, password) {
    // let xstreamUrl ='https://cors.b-cdn.net/' + dnsUrl + '/player_api.php?username=' + username + '&password=' + password;
      
      // let xstreamUrl = dnsUrl + '/player_api.php?username=' + username + '&password=' + password;
      // const body = new HttpParams()
      // .set('username',username)
      // .set('password',password)
      // return this.http.post('http://mytv.digital',body);
      const body = new HttpParams()
      .set('username',username)
      .set('password',password)
      .set('type',5)
      .set('dns',dnsUrl)
      .set('playlist_name',playlist)
      return this.http.post('https://dev.login.purpletv.app/api/add-playlists',body,{headers:this.headers});
  }

  serverDnsLogins(dnsUrl, username, password) {
    const xtoken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2Rldi5sb2dpbi5wdXJwbGV0di5hcHAvYXBpL2xvZ2luIiwiaWF0IjoxNzQ0MzQ5MTY2LCJleHAiOjE3NDY5NDExNjYsIm5iZiI6MTc0NDM0OTE2NiwianRpIjoiVW9CRzN5WWxWWFVMRnRmRiIsInN1YiI6IjM5MjQ2IiwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.jgJ9A_gvWXH5mQ9PESId_j2wBrkWfN0FA2ywVnl1D5s'
    // let xstreamUrl ='https://cors.b-cdn.net/' + dnsUrl + '/player_api.php?username=' + username + '&password=' + password;
    let xstreamUrl = dnsUrl + '/player_api.php?username=' + username + '&password=' + password;
    const body = new HttpParams()
    .set('username',username)
    .set('password',password)
    .set('type',5)
    .set('dns','https://tvportal.one')
    .set('playlist_name','Sri Ram')
    return this.http.post('https://dev.login.purpletv.app/api/add-playlists',body);
  }


  XstreamLogin(dnsUrl,username,password){
    let xstreamUrl ='https://cors.b-cdn.net/' + dnsUrl + '/player_api.php?username=' + username + '&password=' + password;
    return this.http.get(xstreamUrl);
  }
  validateURL(url){
    console.log(url);
    
    return this.http.get(url);
  }
  validatePostURL(param){
    
    const url = `${param.dns}/player_api.php`
    const body = new HttpParams()
    .set(`username`,param.username)
    .set(`password`,param.password)

    return this.http.post(url,body)
  }
  

  OneStreamLogin(dnsUrl: string, formData: FormData) {
    return this.http.post(`${dnsUrl}` + `/play/b2c/v1/auth`, formData);
  }
  
  callURLEncodedApi(url, body, headers: any = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })) {
    return this.http.post(''+url, body, { headers })
  }

  changePassword(data){
    const formData={
      current_password:data.currentPassword,
      new_password:data.password
    }
    return this.http.post(`${environment.baseUrl}/change-password`,formData,{headers:this.headers});
  }
  deteteAccount(){
  const token = this.utilService.getValueCookie(Constant.USERTOKEN) || '';
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`
  });
    return this.http.delete(`${environment.baseUrl}/delete-account`,{headers});
  }
  saveEncryptedPassword(password: string): void {
    const hash = CryptoJS.AES.encrypt(password, this.keys.toString());
    localStorage.setItem('en_p', hash);
  }

  getDecryptedPassword(): string | null {
    const hash = localStorage.getItem('en_p');
    return hash ? CryptoJS.AES.decrypt(hash, this.keys).toString(CryptoJS.enc.Utf8) : null;
  }
}
